import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import IconButton from '@mui/material/IconButton'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import format from 'date-fns/format'
import { useCallback, useMemo } from 'react'

import { useBookingContext } from '@providers/booking'
import { TCartRequestDates } from '@providers/booking/types'
import { i18WithParams as t } from '@shared/locale'

export const DatesViewer = () => {
  const bookingCtx = useBookingContext()
  const datesSelected = useMemo(
    () => bookingCtx.state.cart.requestDates || ([] as TCartRequestDates[]),
    [bookingCtx.state.cart.requestDates]
  )

  const onRemoveItem = useCallback(
    (ev: React.MouseEvent<HTMLButtonElement>) => {
      const { currentTarget: t } = ev
      if (t.dataset.idx) {
        bookingCtx.dispatch({ type: 'SET_REQUEST_DATE', payload: { value: datesSelected[Number(t.dataset.idx)].date } })
      }
    },
    [bookingCtx, datesSelected]
  )

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell colSpan={10}>
            {t('requestDates.grooms.selectedDays', { selected: String(datesSelected.length) })}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {datesSelected.map((dc, idx) => {
          return (
            <TableRow key={dc.id}>
              <TableCell width="100%">
                <Typography variant="body1" component="span">
                  {format(dc.date, 'MMM dd')}
                </Typography>
              </TableCell>
              <TableCell align="center" width={90}>
                <Tooltip title={t('addonDatePicker.removeDay')} disableInteractive>
                  <IconButton onClick={onRemoveItem} data-idx={idx}>
                    <RemoveCircleOutlineIcon color="primary" />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </TableRow>
          )
        })}
      </TableBody>
    </Table>
  )
}
